// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1411":"9b58966f","2146":"9b58966f","2414":"1de13a87","5624":"0e5d21ea","7639":"8dd7362c","9294":"0e5d21ea"}[chunkId] + ".chunk.css";
};